const Constants = {
  assetLink:'../../public/assets',
  USER_TOKEN: 'token_user', 
  ROLE: 'role', 
  imageSize: 5000000,
  SPA: 'spa',
  GYM: 'gym',
  RESTAURANT:'restaurant',
  RH: 'rh',
  URL: 'http://146.190.91.81/api/v1',
  IMAGE_LINK: 'http://146.190.91.81/api/downloads/',
}

export default Constants
